import { AutogiroMandateResponse } from 'src/modules/invoice/models/autogiroMandateResponse';
import { AutogiroSearchFilter } from 'src/modules/invoice/models/autogiroSearchFilter';
import { AutogiroMandatePostRequest } from 'src/modules/invoice/models/autogiroMandatePostRequest';
import { AutogiroMandatePutRequest } from 'src/modules/invoice/models/autogiroMandatePutRequest';
import { PagedResult } from '../models/pagedResult';
import AxiosInstance from './axios/interceptor';
import { setPagingParams } from '../functions/createPagingParams';
import { setArrayValue } from '../functions/setArrayValue';

const controller = 'AutogiroMandate';

export const getAllAutogiroMandate = (searchFilter: AutogiroSearchFilter) => {
  const pageIndex = searchFilter?.pageIndex ?? 0;
  const pageSize = searchFilter?.pageSize ?? 50;
  const sortCol = searchFilter?.sortCol ?? 'autogiroMandate_id';
  const sortDir = searchFilter?.sortDir ?? 'desc';

  let extraQuery = '';
  extraQuery += searchFilter?.filter ? `&filter=${searchFilter.filter}` : '';
  extraQuery += searchFilter?.sent !== undefined ? `&sent=${searchFilter.sent}` : '';
  extraQuery += setArrayValue(searchFilter?.status, 'statusList');

  const endpoint = `${controller}/?${setPagingParams({
    pageIndex,
    pageSize,
    sortCol,
    sortDir,
  })}${extraQuery}`;
  return AxiosInstance.get<PagedResult<AutogiroMandateResponse>>(endpoint);
};

export const getAutogiroMandateById = (id: number) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.get<AutogiroMandateResponse>(endpoint);
};

export const cancelAutogiroMandate = (autogiroId: number) => {
  const endpoint = `${controller}/${autogiroId}/Cancel`;
  return AxiosInstance.put<number>(endpoint, autogiroId);
};

export const createAutogiroMandateFile = (invoiceGroup: number, mandateIds: number[]) => {
  const endpoint = `${controller}/CreateFile?ownerId=${invoiceGroup}`;
  return AxiosInstance.put<number>(endpoint, mandateIds);
};

export const createAutogiroMandate = (data: AutogiroMandatePostRequest) => {
  return AxiosInstance.post<AutogiroMandatePostRequest>(controller, data);
};

export const updateAutogiroMandate = (data: AutogiroMandatePutRequest) => {
  return AxiosInstance.put<AutogiroMandatePutRequest>(controller, data);
};

export const deleteAutogiroMandate = (autogiroMandateId: number) => {
  const endpoint = `${controller}/${autogiroMandateId}`;
  return AxiosInstance.delete<number>(endpoint);
};
